export default "__VITE_ASSET__Yvc5_Iz5yPMFYKAwsoZ_8w__"